import { ChangeDetectionStrategy, Component } from "@angular/core";

/** Available with checkout itself, even when the ticket chunk cannot load. */
@Component({
    selector: "app-paid-purchase-preparation",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <main aria-live="polite" aria-busy="true">
            <div class="payment-confirmed" aria-hidden="true">✓</div>
            <h1>Payment received</h1>
            <p>Preparing your tickets...</p>
        </main>
    `,
    styles: [`
        :host { display: flex; min-height: 100%; align-items: center; justify-content: center; background: #fff; color: #172036; }
        main { max-width: 30rem; padding: 2rem; text-align: center; }
        .payment-confirmed { margin: 0 auto 1.5rem; font-size: 2rem; color: #187042; }
        h1 { font-size: 1.6rem; line-height: 1.3; }
        p { line-height: 1.6; }
    `],
})
export class PaidPurchasePreparationComponent {}
